import React from 'react'
import { Modal, Button } from "antd";
import './mandatoryWarning.scss'
import {WarningOutlined} from '@ant-design/icons'

export const MandatoryWarning: React.FC<{
  show: boolean,
  setshow: (show: boolean) => void,
  onContinue: () => void
}> = (props) => {
  return (
    <Modal
      className="ui-program-intervention-tasks__mandatory-warning"
      visible={props.show}
      centered
      onCancel={
        () => props.setshow(false)
      }
      footer={false}
    >
      <div className="content">
        <div className="ui-program-intervention-tasks__mandatory-warning__content__title">
          <WarningOutlined />
          Warning
        </div>
        <div className="ui-program-intervention-tasks__mandatory-warning__content__message">
          {props.children}
        </div>
        <div className="ui-program-intervention-tasks__mandatory-warning__content__footer">
          <Button key="back" onClick={() => props.setshow(false)}>
            Cancel
          </Button>
          <Button key="submit" type="primary" onClick={
            () => {
              props.onContinue()
            }
          }>
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  )
}
